module.exports = __webpack_public_path__ + "static/media/T2.d9e4cca4.png";